import { render, staticRenderFns } from "./EditarVencedoresLoteTable.vue?vue&type=template&id=586ca269"
import script from "./EditarVencedoresLoteTable.vue?vue&type=script&lang=ts"
export * from "./EditarVencedoresLoteTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports